import React from 'react';
import Sidebar from './Sidebar';
import useHasPermission from '../utils/useHasPermission';
import { notification, index } from '../utils/constants';

const SidebarWrapper = () => {
  const hasPermission = useHasPermission(notification, index);
  return <Sidebar hasPermission={hasPermission} />;
};

export default SidebarWrapper;
